import Service from "../Service";

const resource = "approvalcircuit/";

export default {
  save(usr, requestID) {
    return Service.post(resource + "save", usr, {
      params: { requestID: requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },  
  massiveReplace(oldPstId, newPstId, requestID) {
    return Service.post(resource + "massivereplace", null, {
      params: { oldPstId: oldPstId, newPstId: newPstId, requestID: requestID },
    });
  },
};